<template>
  <svg aria-hidden="true" :fill="color" :style="{
    width: size,
    height: size,
    cursor: cursor,
  }">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "#192434",
  },
  size: {
    type: String,
    default: "1em",
  },
  cursor: {
    type: String,
    default: ''
  }
});
const symbolId = computed(() => `#icon-${props.name}`);
</script>
<!-- \emp\vite\plugins\index.js
createSvgIconsPlugin({
  iconDirs: [path.resolve(process.cwd(), 'src/assets/svg')], // 指定svg存放的路径
  symbolId: "icon-[dir]-[name]",
}),
main.js
import 'virtual:svg-icons-register'; // svg
<comp-svg name="icon-setting" size="20px" color="red" style="margin-left: 16px;" /> -->